import Grid from '@material-ui/core/Grid'
import {Trans} from 'react-i18next'
import messages from '../../assets/messages'
import Loading from '../Common/Loading'
import PageSubTitle from '../Common/PageSubTitle'
import {PammNetworkTree} from '../PammNetworkTree'
import {usePammNetworkOffers} from '../PammNetworkTree/usePammNetworkOffers'

/**
 * Agent-facing PAMM offers page (reached via the "PAMM Agent Offers" sidebar menu).
 *
 * Renders the agent's own offer together with its full downline as a hierarchical,
 * expandable tree (PT-5399). A viewer who is also a Money Manager can switch the same page
 * to their full network from the perspective toggle (PT-5717); the page opens on the agent
 * view either way, because that is the perspective this entry point is about.
 */
export const PammAgentOffers = () => {
  const {agentOffers, error, loading, masterOffers} = usePammNetworkOffers()
  if (error) return <pre>{JSON.stringify(error)}</pre>
  if (loading) return <Loading />

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PageSubTitle>
          <Trans {...messages.pammAgentOffers} />
        </PageSubTitle>
      </Grid>
      <Grid item xs={12}>
        <PammNetworkTree agentOffers={agentOffers} masterOffers={masterOffers} defaultView="agent" />
      </Grid>
    </Grid>
  )
}
